/**
 * Hybrid Switch Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import Icon from "@sproutsocial/seeds-react-icon";
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import { StyledSwitchButton } from "./styles"; // Styled-components version
import { SwitchTailwind } from "./SwitchTailwind"; // Tailwind version
import type { TypeSwitchProps } from "./SwitchTypes";

const SwitchHybrid = React.forwardRef<HTMLButtonElement, TypeSwitchProps>(
  (props, ref) => {
    const {
      onClick,
      loading = false,
      checked,
      disabled = false,
      ...rest
    } = props;

    if (hasStyledProps(rest)) {
      const handleClick = (e: React.SyntheticEvent<HTMLButtonElement>) => {
        if (!disabled) {
          onClick(e, !checked);
        }
      };

      return (
        <StyledSwitchButton
          type="button"
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={handleClick}
          className={loading ? "loading" : ""}
          ref={ref}
          {...rest}
        >
          {checked ? <Icon aria-hidden size="mini" name="check-solid" /> : null}
        </StyledSwitchButton>
      );
    }

    // Use Tailwind version (preferred - better performance)
    return <SwitchTailwind {...props} ref={ref} />;
  }
);

SwitchHybrid.displayName = "Switch";
export default SwitchHybrid;
